module.exports = __webpack_public_path__ + "static/media/expressjs.caf14960.svg";